// extracted by mini-css-extract-plugin
export var actionIcon = "_sn-0";